import { render, staticRenderFns } from "./GcodePreview.vue?vue&type=template&id=163dc133&scoped=true&"
import script from "./GcodePreview.vue?vue&type=script&lang=ts&"
export * from "./GcodePreview.vue?vue&type=script&lang=ts&"
import style0 from "./GcodePreview.vue?vue&type=style&index=0&id=163dc133&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163dc133",
  null
  
)

export default component.exports